import React from 'react';

const Home = () => (
  <div className="Home">
    <h2 className="home-head">Welcome to our page</h2>
    <p className="home-content">
      An electronic calculator is typically a portable electronic device used to
      perform calculations, ranging from basic arithmetic to complex mathematics.
      The first solid-state electronic calculator was created in the early 1960s.
      Pocket-sized devices became available in the 1970s, especially after the Intel 4004,
      the first microprocessor, was developed by Intel for the Japanese calculator company
      Busicom. They later became used commonly within the petroleum industry (oil and gas).
    </p>
    <p>
      Modern electronic calculators vary from cheap, give-away, credit-card-sized models to
      sturdy desktop models with built-in printers.
      They became popular in the mid-1970s as the incorporation of integrated circuits reduced
      their size and cost.
      By the end of that decade, prices had dropped to the point
      where a basic calculator was affordable to most and they became common in schools.
    </p>
  </div>
);

export default Home;
